import { render } from "./Jiagong.vue?vue&type=template&id=36a16a60&scoped=true"
import script from "./Jiagong.vue?vue&type=script&lang=js"
export * from "./Jiagong.vue?vue&type=script&lang=js"

import "./Jiagong.vue?vue&type=style&index=0&id=36a16a60&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a16a60"]])

export default __exports__